import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section id="top" className="relative w-full h-[640px] md:h-[720px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/edited_83ae7ca186d2cc286a9d2ffba75739da_b392aa7b.jpg"
        alt="東方醫學意象背景"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/35 to-black/10"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 h-full flex items-center">
        <div className="w-full md:w-[58%] text-white">
          <img
            src="https://storage.helloreaddy.io/project_files/5083fe3c-0446-4f05-ab30-834aed56ded7/6a623ee9-74ef-4c4d-9fa4-01d9417285e9_compressed_logo5.webp"
            alt="ISHB Logo"
            className="h-20 md:h-24 w-auto object-contain mb-2 -ml-3"
          />
          <h1 className="text-3xl md:text-5xl font-semibold leading-tight tracking-wide">
            國際病變皮膚
            <br />
            大健康及美業學會
          </h1>
          <p className="mt-6 text-white/85 max-w-lg leading-relaxed">
            專注病變皮膚修復、疤痕重建與逆齡抗衰老。以離子紅光細胞再生技術，為求醫的你提供安全、專業的治療方案，重現健康美麗的肌膚。
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link
              to="/#treatments"
              className="px-7 py-3 rounded-md bg-brand-600 hover:bg-brand-700 text-white text-sm tracking-wider whitespace-nowrap cursor-pointer transition"
            >
              了解治療服務
            </Link>
            <Link
              to="/courses"
              className="px-7 py-3 rounded-md border border-white/80 hover:bg-white hover:text-brand-700 text-white text-sm tracking-wider whitespace-nowrap cursor-pointer transition"
            >
              最新課程
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}